<template>
    <div class="con">
      
    <div class="slidebar" :class="{show:slidebarIsShow}">
      <div class="mask" @click="closeSlidebar"></div>
      <div class="menu">
        <div class="title">
          <div class="back" @click="closeSlidebar"><i class="el-icon-arrow-left"></i></div>
          <span>展品分类</span>
        </div>
        <ul>
            <li :class="{active:categoryIndex == 0}" 
              data-id="" data-index="0" :data-total="totals"
              v-if="clist.length>1"
              @click="categoryChange">
              <span>全部 ({{totals}})</span>
            </li>
            <li 
              :class="{active:categoryIndex == index+1}" 
              @click="categoryChange"
              :data-id="item.id"
              :data-index="index+1"
              :data-total="item.count"
              v-for="(item,index) in clist" 
              :key="index">
              <span>{{item.name}} ({{item.count}})</span>
            </li>
          </ul>
      </div>
    </div>


      <div class="leftbar" v-if="clist.length>0">
        <ul>
          <li :class="{active:categoryIndex == 0}" 
            data-id="" data-index="0" :data-total="totals"
            v-if="clist.length>1"
            @click="categoryChange">
            <span>全部 ({{totals}})</span>
          </li>
          <li 
            :class="{active:categoryIndex == index+1}" 
            @click="categoryChange"
            :data-id="item.id"
            :data-index="index+1"
            :data-total="item.count"
            v-for="(item,index) in clist" 
            :key="index">
            <span>{{item.name}} ({{item.count}})</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <ul v-if="productList.length>0">
          <li v-for="(item,index) in productList" :key="index">
            <router-link 
            :to="{path:'/seller/'+sid+'/product/'+item.id}">
              <div class="img-box">
                <img :src="item.image" alt="">
                <div class="mask"><i class="el-icon-d-arrow-right"></i></div>
              </div>
              <h4 class="ell">{{item.name}}</h4>
            </router-link>
          </li>
        </ul>
        <div class="pagination" v-show="productList.length>0">
          <el-pagination
            @current-change="setPage"
            layout="prev, pager, next"
            :pageSize="3"
            :total="total">
          </el-pagination>
        </div>
        <Empty text="暂无展品" :end="loadEnd" v-if="productList.length===0"></Empty>
        <Loading :show="loadingShow"></Loading>
      </div>
    </div>
</template>

<script>
import Page  from '@/components/page.vue'
import Empty from '@/components/empty.vue'
import Loading from '@/components/loading.vue'


import { getProductList } from '@/api/seller.js'

export default {
  name: '',
  components:{Page,Empty,Loading},
  props:{
    clist:{type:Array,default:[]},
    slidebarIsShow:{type:Boolean,default:false}
  },
  data(){
    return {
      loadEnd:false,
      sid:this.$route.params.sid,
      categoryIndex:'',
      categoryId:'',
      total:1,
      page:1,
      productList:[]
    }
  },
  created(){
    this.getProductList();
    this.total = this.totals;
  },
  computed:{
    totals(){
      let totals = 0;
      this.clist.map(res=>{
        totals+=res.count*1
      })
      return totals;
    }
  },
  watch:{
    totals(){
      console.log('watch');
      this.total = this.totals;
    }
  },
  methods:{
    setPage(e){
      this.page=e;
      this.getProductList();
    },
    categoryChange(e){
      const id = e.currentTarget.dataset.id;
      const index = e.currentTarget.dataset.index;
      const total = e.currentTarget.dataset.total*1;
      this.total = total;
      this.categoryId = id
      this.categoryIndex = index;
      this.$emit('close');
      this.getProductList();
    },
    getProductList(){
      this.loadEnd = false;
      this.loadingShow = true;
      this.productList = [];
      getProductList(this.sid,this.categoryId,this.page).then((res)=>{
        this.productList = res;
        this.loadingShow = false;
        this.loadEnd = true;
        console.log(this.productList);
      })
    },
    closeSlidebar(e){
      this.$emit('close');
    }
  }
}
</script>



<style scoped>
.img-box{position:relative;}
.img-box .mask{position:absolute; top:0;bottom:0;left:0;right:0; background:rgba(255,255,255,.5); display:flex; transition-duration:300ms; opacity:0;}
.img-box .mask>i{font-size:1vw; color:#fff; display:block; margin:auto; transition-duration:300ms; transform:scale(.5); width:2.5vw; height:2.5vw; line-height:2.5vw; text-align:center; background:#e70031; border-radius:2.5vw;}
.img-box:hover .mask{opacity:1;}
.img-box:hover .mask>i{transform:scale(1);}

.con{display:flex; background:#f7f7f7; min-height: calc(100vh - 17vw - 12vw);}
.con .leftbar{width:20vw; flex:0 0 20vw; background:#fff; margin:1vw;}
.con .leftbar .title{background:#fff; text-indent:2vw; height:3.5vw; line-height:3.5vw;border-bottom:1px solid #f7f7f7;}
.con .leftbar ul{background:#fff;}
.con .leftbar ul li{padding:1.2vw 1vw 1.2vw 2vw; border-bottom:1px solid #f7f7f7; cursor:pointer; font-size:1vw;}
.con .leftbar ul li.active,
.con .leftbar ul li.active:hover{background:#d71e27; color:#fff;}
.con .leftbar ul li:hover{background:#f7f7f7;}

.con .right{flex:1 1 auto; margin:1vw 0 1vw 1vw;}
.con .right li{width:19.5vw; border:1px solid #eee; background:#fff; display:inline-block; margin:0 1.4vw 1vw 0;}
.con .right li:nth-of-type(3n){margin-right:0;}
.con .right li .img-box{background:#fff;width:19.5vw; height:19.5vw; display:flex; border-bottom:1px solid #eee; transition-duration:300ms; overflow:hidden;}
.con .right li .img-box>img{width:19.2vw; height:19.2vw; margin:auto; object-fit:cover; transform:scale(1); transition-duration:300ms;}
.con .right li .img-box:hover>img{background:#f7f7f7; transform:scale(1.05);}
.con .right li h4{height:3vw; line-height:3vw; width:18vw; text-indent:0.5vw;}

.slidebar{position:fixed; z-index:99; top:0vw; bottom:0; left:12.5%; right:0; background:rgba(0,0,0,.5); transition-duration:500ms; opacity:0; visibility:hidden;}
.slidebar .mask{position:absolute;top:0;bottom:0;left:0;right:0;}
.slidebar.show{opacity:1; visibility:visible;}
.slidebar .menu{position:absolute; top:0; bottom:0; right:0; left:50vw; background:#fff; transition-duration:500ms; transform:translate(50vw,0); box-shadow:0 -1vw 4vw #666;}
.slidebar.show .menu{transform:translate(0,0);}
.slidebar .menu .title{height:5vw; line-height:5vw; box-sizing: border-box; color:#000; font-size:1.5vw; font-weight:bold; border-bottom:1px solid #d71e27; display: flex; align-items:center;}
.slidebar .menu .title .back{width:5vw; height:5vw; text-align:center; line-height:5.4vw; cursor:pointer; overflow:hidden;}
.slidebar .menu .title .back i{font-size:2vw; font-weight:bold; padding:0 1vw;}
.slidebar .menu ul{background:#fff; overflow-y:auto; position:absolute;top:5vw; right:0;left:0;bottom:0;}
.slidebar .menu ul li{padding:1.5vw 1vw 1.5vw 1.5vw; border-bottom:1px solid #f7f7f7; cursor:pointer; font-size:1.5vw; transition-duration:300ms;}
.slidebar .menu ul li.active,
.slidebar .menu ul li.active:hover{background:#d71e27; color:#fff;}
.slidebar .menu ul li:hover{background:#f7f7f7;}

.pagination{padding:2vw 0; text-align:center;}

@media (max-width:991px){
.img-box .mask>i{width:5.5vw; height:5.5vw; line-height:5.5vw; border-radius:6vw;
}

.con .leftbar{display:none;}
.con .right{width:99vw; margin-top:2vw;}
.con .right li{width:30vw; margin:0 1.12vw 1vw 1.12vw;}
.con .right li .img-box{width:30vw; height:30vw;}
.con .right li .img-box>img{width:30vw; height:30vw; object-fit:cover;}
.con .right li h4{height:5vw; width:28vw; line-height:5vw; text-indent:1vw;}

.slidebar{position:fixed; z-index:99; top:55px; bottom:0; left:0; right:0; background:rgba(0,0,0,.5); transition-duration:500ms; opacity:0; visibility:hidden;}
.slidebar .mask{position:absolute;top:0;bottom:0;left:0;right:0;}
.slidebar.show{opacity:1; visibility:visible;}
.slidebar .menu{position:absolute; top:0; bottom:0; right:0; left:30vw; background:#fff; transition-duration:500ms; transform:translate(70vw,0); box-shadow:0 -1vw 4vw #666;}
.slidebar.show .menu{transform:translate(0,0);}
.slidebar .menu .title{height:11vw; line-height:11vw; color:#000; font-size:3vw; font-weight:bold; border-bottom:1px solid #ccc; display: flex; align-items:center;}
.slidebar .menu .title .back{width:8vw; height:10vw; text-align:center; line-height:11vw; cursor:pointer; overflow:hidden;}
.slidebar .menu .title .back i{font-size:4vw; font-weight:bold; padding:0 1vw;}
.slidebar .menu ul{background:#fff; overflow-y:auto; position:absolute;top:10vw; right:0;left:0;bottom:0;}
.slidebar .menu ul li{padding:3.5vw 1vw 3.5vw 2.5vw; border-bottom:1px solid #f7f7f7; cursor:pointer; font-size:2vw; transition-duration:300ms;}
.slidebar .menu ul li.active,
.slidebar .menu ul li.active:hover{background:#d71e27; color:#fff;}
.slidebar .menu ul li:hover{background:#f7f7f7;}

}
</style>

<style>
.el-pager li.active,
.el-pager li:hover,
.el-pagination button:hover
{color:#e70031;}
</style>